<template>
  <v-container>
    <h1>DIXIE FIRE INTAKE FORM</h1>
    <div v-if="formComplete">
      THANK YOU FOR YOUR SUBMISSION. SOMEONE WILL CONTACT YOU SHORTLY. YOU CAN
      ALSO REACH OUT TO US ANYTIME AT (310) 552-3800.
    </div>
    <v-stepper v-model="e13" vertical non-linear v-if="!formComplete">
      <v-btn text style="background-color: #303030">
        <v-stepper-step step="1" complete @click="e13 = 1">
          CONTACT DETAILS (REQUIRED)
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="1" class="ma-0 pa-1">
        <v-card class="mb-5" light>
          <v-container class="ma-auto">
            <v-form id="party" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>PRIMARY CONTACT</div>
                      <!-- NAME  -->
                      <v-layout row wrap class="ma-auto">
                        <v-text-field
                          label="FIRST NAME"
                          v-model="firstName"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                          autofocus
                        ></v-text-field>
                        <v-text-field
                          label="LAST NAME"
                          v-model="lastName"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                      <!-- PHONE AND EMAIL -->
                      <v-layout row wrap class="ma-auto">
                        <v-text-field
                          label="EMAIL"
                          v-model="email"
                          width="100%"
                          class="ma-2"
                          :rules="[rules.email]"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="PHONE"
                          v-model="phone"
                          width="100%"
                          class="ma-2"
                          v-mask="phoneMask"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                      <!-- PRIMARY?  -->
                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="ARE YOU THE PRIMARY CONTACT FOR MATTERS RELATING TO THE FIRE?"
                          v-model="primary"
                          dense
                          outlined
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 2">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <v-btn text style="background-color: #303030">
        <v-stepper-step step="2" complete @click="e13 = 2">
          TYPE OF LOSS
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="2" class="ma-0 pa-1">
        <v-card class="mb-5" light>
          <v-container class="ma-auto">
            <v-form id="location" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>WHAT KIND OF LOSS DID YOU INCURE?</div>
                      <v-expansion-panels inset multiple>
                        <!-- DWELLING (HOME)  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >DWELLING (HOME)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Total Loss"
                              v-model="losses"
                              value="Dwelling (Home) - Total Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Partial Structure Loss"
                              v-model="losses"
                              value="Dwelling (Home) - Partial Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage Only"
                              v-model="losses"
                              value="Dwelling (Home) - Smoke Damage Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Dwelling (Home) - No Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="dwellingOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherDwellingDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              hint="INCLUDE YOUR RELATIONSHIP TO PROPERTY, STRUCTURE SIZE, NUMBER OF ROOMS, LOT SIZE"
                              v-if="dwellingOther"
                            ></v-textarea>
                            <v-btn
                              v-if="otherDwellingDamage"
                              @click="addOtherDwellingDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- OTHER STRUCTURES (UNATTACHED TO THE HOME) -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >OTHER STRUCTURES (UNATTACHED TO THE
                            HOME)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Total Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Total Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Partial Structure Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Partial Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage Only"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Smoke Damage Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - No Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="structureOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherStructureDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              hint="INCLUDE YOUR RELATIONSHIP TO PROPERTY, STRUCTURE SIZE, NUMBER OF ROOMS, LOT SIZE"
                              v-if="structureOther"
                            ></v-textarea>
                            <v-btn
                              v-if="structureOther"
                              @click="addOtherStructureDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- CONTENTS/PERSONAL PROPERTY  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >CONTENTS/PERSONAL
                            PROPERTY</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Many Contents Lost"
                              v-model="losses"
                              value="Contents/Personal Property - Many Contents Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="Some Contents Lost"
                              v-model="losses"
                              value="Contents/Personal Property - Some Contents Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage/Spoiled Contents Only"
                              v-model="losses"
                              value="Contents/Personal Property - Smoke Damage/Spoiled Contents Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="contentsOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherContentDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              v-if="contentsOther"
                            ></v-textarea>
                            <v-btn
                              v-if="contentsOther"
                              @click="addOtherContentDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- EVACUATION COSTS  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >EVACUATION COSTS</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Evacuation Costs"
                              v-model="losses"
                              value="Evacuation Loss"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR EVACUATION LOSS"
                              v-model="evacuationCostDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- PERSONAL INJURY -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >PERSONAL INJURY</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Personal Injury"
                              v-model="losses"
                              value="Personal Injury"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR INJURIES"
                              v-model="personalInjuryDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- EMOTIONAL DISTRESS/ANNOYANCE -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >EMOTIONAL
                            DESTRESS/ANNOYANCE</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Emotional Distress/Annoyance"
                              v-model="losses"
                              value="Emotional Distress"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR EMOTIONAL DISTRESS AND/OR ANNOYANCE"
                              v-model="emotionalDistressDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- OTHER LOSSES  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >OTHER LOSSES</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Other Losses"
                              v-model="losses"
                              value="Other Losses"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE OTHER LOSSES NOT LISTED"
                              v-model="otherLossDescription"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-card-actions>
        <v-progress-circular
          class="text-center ma-auto"
          indeterminate
          size="84"
          v-if="overlay"
        ></v-progress-circular
        ><v-btn
          @click="submit"
          rounded
          outlined
          color="green"
          text
          :disabled="!validForm"
          v-if="!overlay"
          >SUBMIT</v-btn
        ></v-card-actions
      >
    </v-stepper>
  </v-container>
</template>

<script>
import * as firebase from "firebase";
import * as moment from "moment";
import { mask } from "vue-the-mask";
// import slugify from "slugify";

export default {
  directives: {
    mask
  },
  data: () => ({
    e13: 1,
    primary: null,
    phoneMask: "(###) ###-####",
    dateMask: "##/##/####",
    submissionDate: moment().format("LL"),
    firstName: null,
    lastName: "",
    phone: null,
    dateOfBirth: null,
    email: "",
    // streetAddress: null,
    // city: null,
    // state: null,
    zipCode: null,
    //if mailing different from current address

    relationshipToLossLocation: null,
    relationshipToLossLocationOptions: [
      "Owner",
      "Renter/Lessee",
      "Other Resident",
      "Your Workplace",
      "Lienholder",
      "Easement-holder",
      "Other"
    ],
    otherRelationshipToLossLocation: null,
    lossLocationStreetAddress: null,
    lossLocationCity: null,
    lossLocationState: null,
    lossLocationZipCode: null,

    lossLocationHomeSize: null,
    lossLocationLotSize: null,
    lossLocationNumberOfRooms: null,
    lossLocationAPNnumber: null,
    currentAddressSameAsMailing: false,
    additionalLossLocations: null,

    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    },
    losses: [],
    dwellingOther: false,
    structureOther: false,
    contentsOther: false,
    landscapingOther: false,
    incomeLossOther: false,

    otherDwellingDamage: null,
    otherStructureDamage: null,
    otherContentDamage: null,
    otherLandscapingDamage: null,
    landscapingDamageDescription: null,
    evacuationCostDescription: null,
    personalInjuryDescription: null,
    emotionalDistressDescription: null,
    harmToPetsDescription: null,
    damageToCropsForProfitDescription: null,
    otherLossDescription: null,
    otherIncomeLoss: null,
    vehicleDamage: {
      description: null,
      insurer: null,
      policyNumber: null,
      compensation: null
    },

    overlay: false,
    formComplete: false
  }),
  computed: {
    validForm() {
      if (
        this.firstName !== null &&
        // this.email !== null &&
        this.phone !== null
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    submit() {
      //take each plaintiff and add to a plaintiff's array

      if (this.validForm) {
        this.overlay = true;
        let content = {
          primary: null,

          submissionDate: moment().format("LL"),
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          dateOfBirth: this.dateOfBirth,
          email: this.email,
          losses: this.losses
        };
        const sendNewFireClientEmail = firebase
          .functions()
          .httpsCallable("sendNewFireClientEmail");
        //ADD MATTER
        sendNewFireClientEmail(content)
          .then(() => {
            this.overlay = false;
            this.formComplete = true;
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        alert(
          "PLEAS MAKE SURE TO INCLUDE VALID CONTACT INFORMATION BEFORE SUBMITTING"
        );
      }

      //client should know when their intake is done
      // alert("THANK YOU FOR YOUR SUBMITTION. SOMEONE WILL CONTACT YOU SHORTLY WITH MORE INFORMSTION - IF YOU HAVE ANY ")
    }
  }
};
</script>
